export enum IPageStatus {
    /** 预热 */
    EARLY = 'EARLY',
    /** 正式 */
    REGULAR = 'regular', // 正式
}
